// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
import api from '../../../services/api';

/**
 * Looks a voucher up by code before anything is deducted. Returns balance,
 * expiry, status and whether it is redeemable at this shop, so the operator
 * can tell the customer where they stand.
 */
export const scanVoucherService = async (data) => {
  return api('/Sellitback.svc/ScanVoucher', data, 'POST');
};

/**
 * Records the deduction. Takes the voucher Code and Amount - the old
 * BookshopCustomerId/RedeemValue pair addressed the retired pooled customer
 * balance and is no longer accepted.
 */
export const redeemVoucherService = async (data) => {
  return api('/Sellitback.svc/RedeemVoucher', data, 'POST');
};
